import type { View } from 'StackHandler';
import { StackHandlerContext, StackStateContext } from 'context/StackHandlerContext';
import { useContext } from 'react';

export const useStackHandler = () => {
  const handler = useContext(StackHandlerContext);

  if (!handler) {
    throw new Error('useStackHandler must be used within a useStackHandlerProvider');
  }

  return handler;
};

export const useCurrentView = (): View | undefined => {
  const stack = useContext(StackStateContext);

  if (!stack) {
    throw new Error('useCurrentView must be used within a StackHandlerContextProvider');
  }

  return stack[stack.length - 1];
};
